<template>
    <div class="frontend">
        <router-link  to="/cockpit"  class="cockpitpreview" v-for="cockpit in cockpits" v-bind:key="cockpit.value">
            <img v-bind:src="cockpit.img" alt="cockpit image"/>
            <span>{{ cockpit.name }}</span>
        </router-link>

    </div>
</template>
<script>

	import {mapState} from 'vuex'

	export default {

		computed: mapState(['cockpits']),

		created() {
			this.$store.dispatch('loadCockpitlist');
		}
	}
</script>